export class Contact {
  id: number;
  email: string;
  phone: string;
  isEmailConfirmed: boolean;
  isActive: boolean;
  insAt: string;
  contactListCustomFields: ContactListCustomFields[];
  contactLists: string[];
}

export class ContactListCustomFields {
  idContactContactList: number;
  idContactList: number;
  name: string;
  isUnsubscribed: boolean;
  customFieldJson: CustomFieldJson[];
}

export class CustomFieldJson {
  idCustomField: string;
  value: string;
  type: string;
  name: string;
  isRequired: boolean;
}
